import React from "react";
// import { Layout } from "../../_metronic/layout";
import Layout from './Layout';
import { Church411 } from "../../components/User/Church411";

export const Church411Page = () => <Layout><Church411></Church411></Layout> 
